import { BASE_UNIT } from "../constants";
export function units(x, asNumber = false) {
    const value = BASE_UNIT * x;
    return asNumber ? value : `${value}px`;
}
export function snap(x, asNumber = false) {
    const value = Math.round(x / BASE_UNIT) * BASE_UNIT;
    return asNumber ? value : `${value}px`;
}
